'use client';

import { useState } from 'react';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
  TextField,
  Box,
  BoxProps,
} from '@mui/material';
import { useItems, useMatchsPlannerContext } from '@scorenco/components';
import { Types } from '@scorenco/core';

import { MatchRowForm } from './MatchRowForm';

type ConvocationSettings = {
  __typename: 'widgets_convocation_settings';
  exclude_task_ids?: number[];
};

type MatchPlanningFormProps = Omit<BoxProps, 'css'> & {
  club: Types.Clubs_Club;
  convocationSettings?: ConvocationSettings;
};

export const MatchPlanningForm = ({
  club,
  convocationSettings,
  ...rest
}: MatchPlanningFormProps) => {
  const { events, tasks } = useMatchsPlannerContext();
  const [searched, setSearched] = useState<string | undefined>('');

  const items = useItems(events);

  // On affiche rien s'il n'y a pas de match
  if (!items.length) {
    return null;
  }

  return (
    <Box {...rest}>
      {!!events?.length && (
        <TextField
          label="Rechercher"
          value={searched}
          variant="standard"
          onChange={(e) => setSearched(e.target.value)}
          sx={{ width: '15rem', marginLeft: '1.5rem', mb: 2 }}
        />
      )}
      <TableContainer sx={{ borderRadius: 0, borderLeft: 0, borderRight: 0 }}>
        <Table
          sx={{
            minWidth: 650,
            borderCollapse: 'collapse',
          }}
          stickyHeader
        >
          <TableHead
            style={{ tableLayout: 'fixed', position: 'sticky', top: 0 }}
          >
            <TableRow>
              <TableCell
                sx={{
                  minWidth: '12rem',
                }}
              >
                Matchs
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '12rem',
                }}
              >
                Heure de convocation
              </TableCell>
              {tasks
                ?.filter(
                  (task) =>
                    !convocationSettings?.exclude_task_ids?.includes(task.id)
                )
                .map((task) => (
                  <TableCell
                    key={task.id}
                    sx={{
                      minWidth: '12rem',
                    }}
                  >
                    {task.name}
                  </TableCell>
                ))}
              <TableCell
                sx={{
                  minWidth: '21rem',
                }}
              >
                Commentaire
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {items.map((event, index) => (
              <MatchRowForm
                key={index}
                event={event ?? undefined}
                searched={searched}
                club={club}
                convocationSettings={convocationSettings}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
